export default function initializeBip() {
    const bip = new BIP();
}

class BIP {
    constructor() {
        this.init();
    }

    init() {
        if (document.querySelector('.bip-menu')) {
            this.initializeBipMenu();
        }
    }

    initializeBipMenu() {
        const menuItemsWithChildren = document.querySelectorAll('.bip-menu__item[aria-haspopup="true"]');

        menuItemsWithChildren.forEach((menuItem) => {
            const activationButton = menuItem.querySelector('.bip-menu__arrow');
            const subMenu = menuItem.querySelector('.bip-menu__submenu');

            if (activationButton && subMenu) {
                activationButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.toggleSubMenu(menuItem, activationButton, subMenu);
                });
            }
        });
    }

    toggleSubMenu(menuItem, activationButton, subMenu) {
        const isExpanded = activationButton.getAttribute('aria-expanded') === 'true';

        // Toggle the 'active' class on the menu item
        menuItem.classList.toggle('active', !isExpanded);

        // Update the aria-expanded attribute
        activationButton.setAttribute('aria-expanded', !isExpanded);

        // Optionally toggle the visibility of the submenu
        if (subMenu) {
            subMenu.style.display = isExpanded ? 'none' : 'block';
        }
    }
}
